import * as React from "react";

function IconChevronsLeft({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-chevrons-left" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><desc>{"Download more icon variants from https://tabler-icons.io/i/chevrons-left"}</desc><path stroke="none" d="M0 0h24v24H0z" fill="none" /><polyline points="11 7 6 12 11 17" /><polyline points="17 7 12 12 17 17" /></svg>;
}

export default IconChevronsLeft;